import React, { useContext, useMemo } from 'react';
import i18n from '../../js/i18n';
var I18nContext = /*#__PURE__*/React.createContext(i18n);
var I18nContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var translations = _ref.translations,
    children = _ref.children;
  var value = useMemo(function () {
    return Object.assign({}, i18n, typeof translations === 'object' ? translations : {});
  }, [translations]);
  return /*#__PURE__*/React.createElement(I18nContext.Provider, {
    value: value
  }, children);
});
var useI18n = function useI18n(key) {
  if (key === void 0) {
    key = null;
  }
  var context = useContext(I18nContext);
  return typeof key === 'string' ? context[key] : context;
};
export { I18nContext, I18nContextProvider, useI18n };